import React from "react";
import { Download, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DownloadReady = ({ downloadToken }) => (
  <div data-testid="workbook-download-ready" style={{ textAlign: "center" }}>
    <p className="font-heading" style={{ color: "var(--gold-bright)", fontSize: "0.65rem", letterSpacing: "0.4em", marginBottom: "1rem" }}>
      Payment Received ✦
    </p>
    <p style={{ color: "var(--text)", fontSize: "0.95rem", lineHeight: 1.75, marginBottom: "1.5rem" }}>
      Your workbook is ready. A copy of this link has also been sent to your email.
    </p>
    <a
      href={`${API}/ebook/download/${downloadToken}`}
      className="btn-angled"
      data-testid="workbook-download-btn"
      style={{ width: "100%", justifyContent: "center" }}
    >
      <Download size={13} color="#0a0806" />
      Download the Workbook
    </a>
    <p style={{ marginTop: "1rem", color: "var(--text-dim)", fontSize: "0.78rem", lineHeight: 1.6 }} data-testid="workbook-download-help">
      Trouble with your download?{" "}
      <a
        href="mailto:pschlachter@seededsomatics.com?subject=Workbook%20download%20help"
        style={{ color: "var(--gold)", textDecoration: "underline", textUnderlineOffset: "3px" }}
        data-testid="workbook-download-help-email"
      >
        Email us
      </a>{" "}
      and we&rsquo;ll send it to you directly.
    </p>
  </div>
);

const PollingNotice = () => (
  <div data-testid="workbook-polling" style={{ textAlign: "center" }}>
    <p className="font-heading" style={{ color: "var(--gold)", fontSize: "0.65rem", letterSpacing: "0.4em", marginBottom: "0.8rem" }}>
      Confirming Payment…
    </p>
    <p style={{ color: "var(--text-muted)", fontSize: "0.9rem" }}>
      One moment. The grid is checking.
    </p>
  </div>
);

const PurchaseForm = ({ product, email, emailError, submitting, onEmailChange, onPurchase }) => {
  const priceLabel = product ? `$${Number(product.amount).toFixed(2)} ${product.currency?.toUpperCase()}` : "—";
  return (
    <form onSubmit={onPurchase} noValidate data-testid="workbook-form">
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: "1rem", gap: "0.75rem", flexWrap: "wrap" }}>
        <p className="font-heading" style={{ color: "var(--gold)", fontSize: "0.65rem", letterSpacing: "0.32em", margin: 0 }}>
          Introductory Price
        </p>
        <p
          className="font-display"
          data-testid="workbook-price"
          style={{ color: "var(--gold-bright)", fontSize: "1.45rem", fontWeight: 700, letterSpacing: "0.02em", margin: 0 }}
        >
          {priceLabel}
        </p>
      </div>

      <label className="field-label" htmlFor="workbook-email">Email for delivery</label>
      <input
        id="workbook-email"
        name="email"
        type="email"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        placeholder="you@somewhere"
        className="field-input"
        data-testid="workbook-email"
        style={{ marginBottom: emailError ? 0 : "1rem" }}
      />
      {emailError && (
        <p style={{ color: "#c9594c", fontSize: "0.82rem", margin: "0.4rem 0 1rem", fontStyle: "italic" }} data-testid="workbook-email-error">
          {emailError}
        </p>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="btn-angled"
        data-testid="workbook-purchase-btn"
        style={{ width: "100%", justifyContent: "center" }}
      >
        {submitting ? "Opening Checkout…" : (
          <>
            <Lock size={11} color="#0a0806" />
            Get the Workbook · Secure Checkout
          </>
        )}
      </button>
      <p style={{ marginTop: "0.85rem", color: "var(--text-dim)", fontSize: "0.7rem", letterSpacing: "0.1em", textAlign: "center" }}>
        Payment by Stripe · Instant download · Delivered to your email
      </p>
    </form>
  );
};

export const PurchasePanel = (payment) => {
  if (payment.paymentStatus === "paid" && payment.downloadToken) {
    return <DownloadReady downloadToken={payment.downloadToken} />;
  }
  if (payment.polling) {
    return <PollingNotice />;
  }
  return <PurchaseForm {...payment} />;
};
